import { Component, OnInit, Input } from '@angular/core';
import { BillofladingAddressesComponent } from '../billoflading-addresses/billoflading-addresses.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Carrier } from 'src/app/shared/common-components/common-structure';

@Component({
    selector: 'app-frt-billoflading-information',
    templateUrl: './frt-billoflading-information.component.html',
    styleUrls: ['./frt-billoflading-information.component.css'],
    standalone: false
})
export class FRTBillofladingInformationComponent implements OnInit {
  bsModalRef: BsModalRef;
  @Input() shipmentsInfo: any;
  @Input() bookshipmentInfo: any;
  @Input() shipmentCostInfo: any;
  @Input() shipmentDetailsInfo: any;
  @Input() carrier: Carrier;
  @Input() carrierOrganizationInfo: any;
  @Input() sealNos: any;
  @Input() purchaseOrders: any;
  @Input() shipperInfo: any;
  @Input() agencyInfo: any;
  @Input() ratesFrtInfo: any;
  @Input() rateTypesInfo: any;
  @Input() shipmentInfoIdFromUrl: any;
  @Input() isOneTimeShipment: boolean;
  title: '';

  ngOnInit() {
  }

  constructor(private modalService: BsModalService) {
  }

  openAddressVerfiicationDialog() {
    const initialState = {
      modalCalledFrom: 'frtBOL',
      shipmentInfoId: this.shipmentInfoIdFromUrl
    };
    this.bsModalRef = this.modalService.show(BillofladingAddressesComponent, { initialState, class: 'modal-lg' });
  }


}
